import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import MenuMain from './menu-main'
import { useMenuContext } from './useMainMenu'
import LinkGlobalNtt from '../link-global-ntt/link-global-ntt'

import { resolvePctLinkUrl } from '@/internal/utils/resolve-pctlink-url'
import Link from '@/components/link/link'

const Navigation = () => {
  const { menuMainShow } = useMenuContext()
  const data = useStaticQuery(graphql`
    {
      navigationTop: allDatoCmsPctNavigation(
        filter: { codeId: { eq: "navigation-top-navigation" } }
      ) {
        nodes {
          navigationItems {
            ...PctNavigationItems
          }
        }
      }
      navigationMain: allDatoCmsPctNavigation(
        filter: { codeId: { eq: "navigation-main-navigation" } }
      ) {
        nodes {
          navigationItems {
            ...PctNavigationItems
          }
        }
      }
    }
  `)
  const mainNavigationItems = data?.navigationMain?.nodes[0].navigationItems
  const topNavigationItems = data?.navigationTop?.nodes[0].navigationItems[0]

  return (
    <>
      <ButtonNavBar />
      <div
        data-cy="basic-navbar-nav"
        id="basic-navbar-nav"
        className={`navbar-collapse collapse ${menuMainShow ? 'show' : ''}`}
      >
        <MenuMain items={mainNavigationItems} />
        <TopMenu items={topNavigationItems} />
        <GlobalMenu />
      </div>
    </>
  )
}

const TopMenu = ({ items }) => {
  return (
    <div className="d-block d-lg-none">
      <ul className="main-menu-top-dropdown">
        {items?.navigationLinks?.map((item, index) => {
          const url = resolvePctLinkUrl(item)
          return (
            <li key={`main-menu-top-dropdown-${item.id}-${index}`}>
              <Link to={url} openInNewWindow={item.openInNewWindow}>
                {item.externalName}
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
const ButtonNavBar = () => {
  const { menuMainShow, handleMainMenu } = useMenuContext()
  return (
    <button
      id="button-navbar-nav"
      aria-label="navigation mobile"
      aria-controls="basic-navbar-nav"
      className={`navbar-toggler ${menuMainShow ? '' : 'collapsed'}`}
      onClick={() => handleMainMenu()}
      data-cy="mobile-menu-button"
    >
      <span />
      <span />
      <span />
    </button>
  )
}
const GlobalMenu = () => {
  return (
    <div className="d-block d-lg-none ps-3 mt-3">
      <LinkGlobalNtt />
    </div>
  )
}

export default Navigation
